module.exports = __webpack_public_path__ + "media/images/online_talks/btn-94406af17394fdc7513be77d291e35e7.png";